
import Vue from 'vue';

export default {
	namespaced : true,
	state: {
		visibleMegamenuData: {
			componentId: "",
			itemId: "",
			subItemId: ""
		},
		activeTopbarStatus: window.me ? "logged-in" : "logged-out",
		schoolTopbarEnabled : null,
		schoolTopbarData : {},
		pageTopbarData: {},
		hasSingleTopbarStatus : false
	},
	actions : {
		setSchoolTopbarData ( {commit,dispatch,rootState} , payload) {
			commit('setSchoolTopbarData',payload);
		},
		setPageTopbarData ( {commit} , payload) {
			commit('setPageTopbarData',payload);
		},
		setPageTopbarDataForStatus ({commit} , payload) {
			commit('setPageTopbarDataForStatus',payload);
		},
		setSchoolTopbarDataForStatus ({commit} , payload) {
			commit('setSchoolTopbarDataForStatus',payload);
		},
		setSchoolTopbarEnabled ( {commit, state,rootState} , payload )  {
			if(!payload && state.pageTopbarData === null){

				for (let topbarStatus in state.schoolTopbarData) {
					if (!state.schoolTopbarData.hasOwnProperty(topbarStatus)) {
						continue;
					}

					let topbarId = state.schoolTopbarData[topbarStatus].sectionId;
					let topbarState = rootState.sections.sectionStates[topbarId];
					let newId = topbarState.createSectionId();
					let clonedData = copyJson(topbarState.myData);

					clonedData = topbarState.changeStateStylesId(clonedData,newId);
					clonedData.sectionId = newId;
					clonedData.content = topbarState.myNode.outerHTML.replace(topbarId,newId);

					if (!state.pageTopbarData) {
						state.pageTopbarData = {};
					}

					Vue.set(state.pageTopbarData, topbarStatus , clonedData);
				}
			}

			commit('setSchoolTopbarEnabled',payload);
		},
		setActiveTopbarStatus ( {commit} , payload) {
			commit('setActiveTopbarStatus',payload);
		},
		setVisibleMegamenuData ( {commit} , payload) {
			commit('setVisibleMegamenuData',payload);
		},		
		setSchoolTopbarElementData ({commit,rootState} , payload){
			let elementState = rootState.elements.elementStates[payload.elementId];
			commit('setSchoolTopbarElementData', {payload, elementState});
		},
		setPageTopbarElementData ({commit,rootState} , payload){
			let elementState = rootState.elements.elementStates[payload.elementId];
			commit('setPageTopbarElementData', {payload, elementState});
		},
		setSchoolTopbarComponentData ({commit,rootState} , payload){
			let componentState = rootState.components.componentStates[payload.componentId];
			commit('setSchoolTopbarComponentData', {payload, componentState});
		},
		setPageTopbarComponentData ({commit,rootState} , payload){
			let componentState = rootState.components.componentStates[payload.componentId];
			commit('setPageTopbarComponentData', {payload, componentState});
		},
		setTopbarStatusData ({commit} , payload){
			commit('setTopbarStatusData', payload);
		},
		removeSchoolTopbarElement ({commit} , payload){
			commit('removeSchoolTopbarElement', payload);
		},
		removePageTopbarElement ({commit} , payload){
			commit('removePageTopbarElement', payload);
		},
		removeSchoolTopbarComponent ({commit} , payload){
			commit('removeSchoolTopbarComponent', payload);
		},
		removePageTopbarComponent ({commit} , payload){
			commit('removePageTopbarComponent', payload);
		},
		setHasSingleTopbarStatus ({commit} , payload) {
			commit('setHasSingleTopbarStatus', payload);
		},
	},
	mutations : {
		setSchoolTopbarDataForStatus (state,payload) {
			console.log("setSchoolTopbarDataForStatus: " , payload)
			Vue.set(state.schoolTopbarData,payload.status,payload.clonedData);
		},
		setPageTopbarDataForStatus (state,payload) {
			if (!state.pageTopbarData) {
				Vue.set(state,'pageTopbarData',{});
			}
			Vue.set(state.pageTopbarData,payload.status,payload.clonedData);
		},
		setHasSingleTopbarStatus (state,flag) {
			state.hasSingleTopbarStatus = flag;
		},
		removeSchoolTopbarComponent (state , componentId) {
			for (let topbarStatus in state.schoolTopbarData) {

				if (!state.schoolTopbarData.hasOwnProperty(topbarStatus)) {
					continue;
				}

				if (state.schoolTopbarData[topbarStatus].components && state.schoolTopbarData[topbarStatus].components[componentId]) {
					Vue.delete(state.schoolTopbarData[topbarStatus].components, componentId);
				}
			}
		},
		removePageTopbarComponent (state , componentId) {
			for (let topbarStatus in state.pageTopbarData) {

				if (!state.pageTopbarData.hasOwnProperty(topbarStatus)) {
					continue;
				}

				if (state.pageTopbarData[topbarStatus].components && state.pageTopbarData[topbarStatus].components[componentId]) {
					Vue.delete(state.pageTopbarData[topbarStatus].components, componentId);
				}
			}
		},
		removeSchoolTopbarElement (state , elementId) {
			for (let topbarStatus in state.schoolTopbarData) {

				if (!state.schoolTopbarData.hasOwnProperty(topbarStatus)) {
					continue;
				}

				if (state.schoolTopbarData[topbarStatus].elements && state.schoolTopbarData[topbarStatus].elements[elementId]) {
					Vue.delete(state.schoolTopbarData[topbarStatus].elements, elementId);
				}
			}
		},
		removePageTopbarElement (state , elementId) {
			for (let topbarStatus in state.pageTopbarData) {

				if (!state.pageTopbarData.hasOwnProperty(topbarStatus)) {
					continue;
				}

				if (state.pageTopbarData[topbarStatus].elements && state.pageTopbarData[topbarStatus].elements[elementId]) {
					Vue.delete(state.pageTopbarData[topbarStatus].elements, elementId);
				}
			}
		},
		setPageTopbarComponentData (state , componentData) {
			let data = componentData.payload;
			let componentState = componentData.componentState;
			let topbarStatus = componentState.topbarStatus;

			// console.log("setPageTopbarComponentData: " , data,componentState)
			if (data && componentState) {

				if (state.pageTopbarData === null) {
					Vue.set(state,"pageTopbarData" , {});
				}

				if (typeof state.pageTopbarData[topbarStatus] === "undefined") {
					Vue.set(state.pageTopbarData, topbarStatus, {});
				}

				if (typeof state.pageTopbarData[topbarStatus].components === "undefined") {
					Vue.set(state.pageTopbarData[topbarStatus], "components" , {});
				}

				if (typeof state.pageTopbarData[topbarStatus].components[data.componentId] === "undefined") {
					Vue.set(state.pageTopbarData[topbarStatus].components, data.componentId , {});
				}


				for (let key in data) {

					if (!data.hasOwnProperty(key)
						// || key === "componentId"
					) {
						continue;
					}

					Vue.set(state.pageTopbarData[topbarStatus].components[data.componentId], key, data[key]);
				}
			}
		},
		setSchoolTopbarComponentData(state , componentData) {
			let data = componentData.payload;
			let componentState = componentData.componentState;
			let topbarStatus = componentState.topbarStatus;

			// console.log("setSchoolTopbarComponentData: " , data,componentState)
			if (data && componentState) {

				if (state.schoolTopbarData === null) {
					Vue.set(state,"schoolTopbarData" , {});
				}

				if (typeof state.schoolTopbarData[topbarStatus] === "undefined") {
					Vue.set(state.schoolTopbarData, topbarStatus, {});
				}

				if (typeof state.schoolTopbarData[topbarStatus].components === "undefined") {
					Vue.set(state.schoolTopbarData[topbarStatus], "components" , {});
				}

				if (typeof state.schoolTopbarData[topbarStatus].components[data.componentId] === "undefined") {
					Vue.set(state.schoolTopbarData[topbarStatus].components, data.componentId , {});
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key)
						// || key === "componentId"
					) {
						continue;
					}

					Vue.set(state.schoolTopbarData[topbarStatus].components[data.componentId], key, data[key]);
				}
			}

		},
		setPageTopbarElementData(state , elementData) {
			let data = elementData.payload;
			let elementState = elementData.elementState;
			let topbarStatus = elementState.topbarStatus;

			if (data && elementState) {

				if (state.pageTopbarData === null) {
					Vue.set(state,"pageTopbarData" , {});
				}

				if (typeof state.pageTopbarData[topbarStatus] === "undefined") {
					Vue.set(state.pageTopbarData, topbarStatus, {});
				}

				if (typeof state.pageTopbarData[topbarStatus].elements === "undefined") {
					Vue.set(state.pageTopbarData[topbarStatus], "elements" , {});
				}

				if (typeof state.pageTopbarData[topbarStatus].elements[data.elementId] === "undefined") {
					Vue.set(state.pageTopbarData[topbarStatus].elements, data.elementId , {});
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key)
						// || key === "elementId"
					) {
						continue;
					}

					Vue.set(state.pageTopbarData[topbarStatus].elements[data.elementId], key, data[key]);
				}
			}
		},
		setSchoolTopbarElementData(state , elementData) {
			let data = elementData.payload;
			let elementState = elementData.elementState;
			let topbarStatus = elementState.topbarStatus;

			// console.log("setSchoolTopbarElementData: " , data,elementState);

			if (data && elementState) {

				if (state.schoolTopbarData === null) {
					Vue.set(state,"schoolTopbarData" , {});
				}

				if (typeof state.schoolTopbarData[topbarStatus] === "undefined") {
					Vue.set(state.schoolTopbarData, topbarStatus, {});
				}

				if (typeof state.schoolTopbarData[topbarStatus].elements === "undefined") {
					Vue.set(state.schoolTopbarData[topbarStatus], "elements" , {});
				}

				if (typeof state.schoolTopbarData[topbarStatus].elements[data.elementId] === "undefined") {
					Vue.set(state.schoolTopbarData[topbarStatus].elements, data.elementId , {});
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key)
						// || key === "elementId"
					) {
						continue;
					}

					Vue.set(state.schoolTopbarData[topbarStatus].elements[data.elementId], key, data[key]);
				}
			}
		},
    setSchoolTopbarEnabled(state, flag) {
			state.schoolTopbarEnabled = flag;
		},
		setActiveTopbarStatus ( state , topbarStatus) {
			state.activeTopbarStatus = topbarStatus;
		},
		setVisibleMegamenuData ( state , data) {
			state.visibleMegamenuData = data;
		},
		setSchoolTopbarData ( state , data) {
			state.schoolTopbarData = copyJson(data);
		},
		setPageTopbarData ( state , data) {
			state.pageTopbarData = data;
		},		
		setTopbarStatusData( state, payload){
			let status = payload.status;
			let type = (payload.type.toLowerCase() == 'school-topbar')? 'schoolTopbarData' : 'pageTopbarData' ;
			Vue.set(state[type], status, {...state[type][status], ...payload.data});

		}
	},

}